import { Document } from '@/assets/icons'

interface MedicalFilePillProps {
  fileName: string
  onClick: () => void
}

/**
 * Medical File Pill
 *
 * Displays a clickable pill-style button for a file, used in the medical chronology
 * and medical billing summary in app viewers.
 */
export default function MedicalFilePill(props: MedicalFilePillProps) {
  const { fileName, onClick } = props

  return (
    <button
      onClick={onClick}
      className="text-xs rounded flex items-center px-2 py-1 gap-1.5 min-h-[26px] bg-brand-neutral-50 ring-1 ring-inset ring-brand-neutral-200
      hover:bg-brand-neutral-100 transition-colors w-fit max-w-full"
    >
      <Document className="w-[18px] h-[18px] text-brand-neutral-800 flex-shrink-0" />
      <span className="truncate whitespace-nowrap overflow-hidden font-medium text-brand-neutral-800" title={fileName}>
        {fileName}
      </span>
    </button>
  )
}
